import { applicationRepository } from '@/services/repository-factory'
import Application from '@/services/classes/Application'
import handleErrors from '@/services/handleErrors'
// import startPwa from '@/startPwa'
import setFavicons from '@/services/utils/set-favicon'
import gtm from '@/plugins/gtm'

const { gtmCreate } = gtm

const actions = {
  setSidebarIsShown(val) {
    this.sidebarIsShown = val
  },
  setBackRouteName(val) {
    this.backRouteName = val
  },
  setIsMiniSidebarShown(val) {
    this.isMiniSidebarShown = val
  },
  setIsSidebarShown(val) {
    this.isSidebarShown = val
  },
  async fetchSettings(applicationIsAuth) {
    this.loading = true
    try {
      const response = await applicationRepository.list()
      const settings = new Application(response)

      this.applicationIsAuth = applicationIsAuth
      this.applicationDataFetched = true

      this.clientAdFormats = settings.clientAdFormats
      this.adFormatGroups = settings.adFormatGroups
      this.adNetwork = settings.adNetwork

      // @ TODO REMOVE MOCK AFTER BACKEND BE READY
      this.manifest = {
        name: settings.adNetwork.name,
        short_name: settings.adNetwork.name,
        theme_color: settings.adNetwork.settings.themes.light.primary,
        background_color: settings.adNetwork.settings.themes.black,
        icons: [
          {
            src: settings.adNetwork.settings.pwaFavicon['192x192'],
            sizes: '192x192',
            type: 'image/png'
          },
          {
            src: settings.adNetwork.settings.pwaFavicon['256x256'],
            sizes: '256x256',
            type: 'image/png'
          },
          {
            src: settings.adNetwork.settings.pwaFavicon['384x384'],
            sizes: '384x384',
            type: 'image/png'
          },
          {
            src: settings.adNetwork.settings.pwaFavicon['512x512'],
            sizes: '512x512',
            type: 'image/png'
          }
        ].filter(({ src }) => !!src),
        start_url: window.location.origin,
        display: 'standalone'
      }

      this.adTypes = settings.adTypes
      this.campaignUpdatingRuleTypes = settings.campaignUpdatingRuleTypes
      this.campaignUpdatingRuleConditionFields = settings.campaignUpdatingRuleConditionFields
      this.defaultInPageSkinId = settings.defaultInPageSkinId
      this.defaultUniquesCap = settings.defaultUniquesCap
      this.defaultUniquesTtl = settings.defaultUniquesTtl
      this.directLinkIcons = settings.directLinkIcons
      this.inStreamAdSkipTimeOptions = settings.inStreamAdSkipTimeOptions
      this.limitTypesByPricingModel = settings.limitTypesByPricingModel
      this.mediaFileSizeLimits = settings.mediaFileSizeLimits
      this.minAddFundsAmount = settings.minAddFundsAmount
      this.paymentMethods = settings.paymentMethods
      this.placementTypes = settings.placementTypes
      this.rotationTypes = settings.rotationTypes
      this.cardIoLink = settings.settings.cardIoLink
      this.undefinedSiteId = settings.settings.undefinedSiteId
      this.undefinedSpotId = settings.settings.undefinedSpotId
      this.maxWebPushSubscriptionDays = settings.settings.maxWebPushSubscriptionDays
      this.maxKaminaryScore = settings.maxKaminaryScore
      this.cardVerificationRequiredForPayments =
        settings.settings.cardVerificationRequiredForPayments
      this.companyCardIoLink = settings.settings.companyCardIoLink
      this.defaultRotationHoursThreshold = settings.settings.defaultRotationHoursThreshold
      this.defaultRotationImpressionsThreshold =
        settings.settings.defaultRotationImpressionsThreshold
      this.minLimitInMoney = settings.settings.minLimitInMoney
      this.minLimitInImpressions = settings.settings.minLimitInImpressions
      this.minLimitInClicks = settings.settings.minLimitInClicks
      this.smartBiddingByAdFormat = settings.smartBiddingByAdFormatTypeAndPricingModel
      this.serverTime = settings.serverTime
      this.trafficChartPricingModels = settings.trafficChartPricingModels
      this.trafficQualityTypes = settings.trafficQualityTypes
      this.twoFactorAuthenticationMethods = settings.twoFactorAuthenticationMethods
      this.apiTokenScopes = settings.apiTokenScopes
      this.notificationCategoryGroups = settings.notificationCategoryGroups
      this.notificationCategories = settings.notificationCategories
      this.trafficProviderMethodTypes = settings.trafficProviderMethodTypes
      this.trafficProviderPricingModels = settings.trafficProviderPricingModels
      this.trafficProviderVerticalTypes = settings.trafficProviderVerticalTypes
      this.flatDealAdFormatIds = settings.flatDealAdFormatIds
      this.flatDealTiers = settings.flatDealTiers
      this.flatDealTrafficTypes = settings.flatDealTrafficTypes
      this.maxCampaignUpdatingRuleConditions = settings.maxCampaignUpdatingRuleConditions
      this.flatDealCountryGroups = settings.flatDealCountryGroups
      this.flatDealDefaultLimitType = settings.flatDealDefaultLimitType
      this.flatDealDefaultValueKey = settings.flatDealDefaultValueKey
      this.flatDealApplicationLimitTypes = settings.flatDealApplicationLimitTypes

      if (this.getLocales.some(({ value }) => value === localStorage.locale)) {
        this.setLocale(localStorage.locale)
      }

      if (!this.pwaIsStarted) {
        // await startPwa(settings.adNetwork.settings.enablePwa)
        this.pwaIsStarted = true
      }

      if (!this.gtmIsCreated && !!settings.adNetwork.settings.gtmId) {
        gtmCreate(window, document, 'script', 'dataLayer', settings.adNetwork.settings.gtmId)
        this.gtmIsCreated = true
      }

      setFavicons(settings.adNetwork.settings.favicons)
    } catch (error) {
      handleErrors(error)
    }
    this.loading = false
  },
  setLocale(locale) {
    this.locale = locale
  },
  setVuetifyColor(vuetify) {
    const themeLight = this.adNetwork.settings.themes.light
    vuetify.themes.value.light.colors = {
      ...vuetify.themes.value.light.colors,
      black: themeLight.black,
      white: themeLight.white,
      error: themeLight.error,
      warning: themeLight.warning,
      success: themeLight.success,
      info: themeLight.info,
      'info-500': themeLight.info500,
      primary: themeLight.primary,
      'on-primary': '#ffffff',
      'primary-500': themeLight.primary500,
      'secondary-50': themeLight.secondary50,
      'secondary-100': themeLight.secondary100,
      'secondary-200': themeLight.secondary200,
      'secondary-400': themeLight.secondary400,
      'secondary-600': themeLight.secondary600,
      'secondary-800': themeLight.secondary800,
      'recommendation-100': themeLight.recommendation100,
      'recommendation-200': themeLight.recommendation200,
      accent1: themeLight.accent1,
      accent2: themeLight.accent2,
      accent3: themeLight.accent3,
      accent4: themeLight.accent4,
      accent5: themeLight.accent5
    }
  }
}

export default actions
